import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';
import { AlertsService } from '../../services/alerts.service';
import cloneDeep from 'lodash/cloneDeep';

interface SortPref {
  fieldName: string | null;
  isAscending: boolean;
  keyType: number;
  sequence: number;
}

/**
 * Component for managing a user's search results options.
 */
@Component({
	selector: 'user-results-opts',
	templateUrl: './results-opts.component.html',
	styleUrl: './results-opts.component.css'
})
export class ResultsOptsComponent implements OnInit {

	LOCALIZATION: any;

	searchPrefs: any[] = [];
	fieldPrefs: any[] = [];
	resultsPrefs = [
		'RESULT_LIST_DISPLAY_TYPE',
		'DOCSUM_TYPE',
		'DOCSUM_NUM_SENTENCES_PROPERTY',
		'DOCSUM_MAX_SENTENCE_LEN_PROPERTY',
		'NUMBER_DOCUMENTS_PER_PAGE',
		'DEFAULT_RESULT_COORD_TYPE'
	];
	
	sortPrefs: SortPref[] = [];
	keyTypeOptions = [
	  { value: 2, name: 'By Rank' },
	  { value: 1, name: 'By Field' },
	  { value: 0, name: 'None' }
	];	

	constructor(
		private alertsService: AlertsService,
		private userService: UserService
	) { }

	ngOnInit(): void {
		this.LOCALIZATION = this.userService.LOCALIZATION;
		this.loadSearchOpts();
	}

	private loadSearchOpts(): void {
		let prefs = cloneDeep(this.userService.user.properties.awpropertyObjectList);
		this.searchPrefs = prefs.sort((a: any, b: any) => a.displayName.localeCompare(b.displayName));
		
		this.fieldPrefs = cloneDeep(this.userService.user.properties.awfieldObjectList);
		
		if (this.userService.user.properties.awsortObjectList?.length > 0) {
		    for (let i = 0; i < this.userService.user.properties.awsortObjectList.length; i++) {
		        let defaultSort = this.userService.user.properties.awsortObjectList[i];
		        this.sortPrefs[i] = {
					fieldName: defaultSort.fieldName,
					isAscending: defaultSort.isAscending,
					keyType: defaultSort.keyType,
					sequence: defaultSort.sequence
				};
		    }
		}
		
		// Add one additional empty option
		this.sortPrefs[this.sortPrefs.length] = {
			keyType: 0,
			sequence: 0,
			isAscending: false,
			fieldName: null
		};
	}

	updatePreferences(): void {
		let prefs = {
			awpropertyObjectList: this.userService.user.properties.awpropertyObjectList,
			awsortObjectList: this.userService.user.properties.awsortObjectList,
			awfieldObjectList: this.userService.user.properties.awfieldObjectList,
			awfieldCollectionObjectList: this.userService.user.properties.awfieldCollectionObjectList,
			awlibraryObjectList: this.userService.user.properties.awlibraryObjectList
		};

		let sortObjectList = [];
		if (this.sortPrefs?.length > 0) {
		    let isRankSort = false;
		    let sortFieldNumber = 0;
		    for (let j = 0; j < this.sortPrefs.length; j++) {
		        if (this.sortPrefs[j].keyType && this.sortPrefs[j].keyType == 1) {
					if (this.sortPrefs[j].fieldName && (this.sortPrefs[j].fieldName ?? '').length > 0) {
						let sortObject = {
							fieldName: this.sortPrefs[j].fieldName,
							isAscending: this.sortPrefs[j].isAscending,
							keyType: this.sortPrefs[j].keyType,
							sequence: sortFieldNumber + 1
						};
		                sortObjectList[sortFieldNumber] = sortObject;
						
		                sortFieldNumber++;
		            }
		        } else {
		            if (!isRankSort && this.sortPrefs[j].keyType > 1) {
		                isRankSort = true;
		                sortObjectList[sortFieldNumber] = {
							fieldName: null,
							isAscending: this.sortPrefs[j].isAscending,
							keyType: this.sortPrefs[j].keyType,
							sequence: sortFieldNumber + 1
						};

		                sortFieldNumber++;
		            }
		        }
		    }
		    prefs.awsortObjectList = sortObjectList;
		    this.sortPrefs = sortObjectList;
		    this.userService.user.properties.awsortObjectList = sortObjectList;
		}
		if (sortObjectList.length == 0) {
		    prefs.awsortObjectList = this.userService.user.properties.awsortObjectList;
		}
		
		for (let i = 0; i < this.resultsPrefs.length; i++) {
		    let property = this.resultsPrefs[i];
		    let value = '';
		    for (let j = 0; j < this.searchPrefs.length; j++) {
		        if (this.searchPrefs[j].name == property) {
		            for (let k = 0; k < prefs.awpropertyObjectList.length; k++) {
		                if (prefs.awpropertyObjectList[k].name == property) {
		                    prefs.awpropertyObjectList[k].value = this.searchPrefs[j].value;
		                    break;
		                }
		            }
		            break;
		        }
		    }
		}		

		let cleanedPrefs = this.userService.cleanData(prefs);

		let payload = {
			prefs: JSON.stringify(cleanedPrefs)
		};

		this.userService.updateUser(payload).then(
			(response: any) => {
				this.alertsService.success({
					message: this.LOCALIZATION.userProfileUpdateSuccess,
					delay: 5000
				});
			},
			(err: any) => {
				console.error("Failed to update user details.", err);
				this.alertsService.error({
					message: this.LOCALIZATION.userProfileUpdateError,
					delay: 5000
				});
			}
		);
	}
}
